import { useEffect, useState } from "react";
import {
    fetchAlergenosAll,
    fetchTipoArmas,
    fetchTipoLicencias,
    fetchTiposDocumento,
} from "../api/catalogosApi";

export function usePerfilCatalogos() {
    const [tiposDocumento, setTiposDocumento] = useState([]);
    const [tipoArmas, setTipoArmas] = useState([]);
    const [tipoLicencias, setTipoLicencias] = useState([]);
    const [alergenosDisponibles, setAlergenosDisponibles] = useState([]);

    useEffect(() => {
        let mounted = true;

        (async () => {
            try {
                const [docs, armas, lic, aler] = await Promise.all([
                    fetchTiposDocumento(),
                    fetchTipoArmas(),
                    fetchTipoLicencias(),
                    fetchAlergenosAll(),
                ]);
                if (!mounted) return;
                setTiposDocumento(docs || []);
                setTipoArmas(armas || []);
                setTipoLicencias(lic || []);
                setAlergenosDisponibles(aler || []);
            } catch (e) {
                console.error("Error cargando catálogos:", e);
            }
        })();

        return () => {
            mounted = false;
        };
    }, []);

    return { tiposDocumento, tipoArmas, tipoLicencias, alergenosDisponibles };
}
